export default __webpack_public_path__ + "static/media/Camping Sale - 1440 x 300 GIF.32264fb6.gif";